import React from 'react';
import IFastEntryProps, { IFastEntryHandle } from './FastEntry.properties';
import FastEntry from './FastEntry';
import FastEntryStateProvider from './FastEntry.context';
import { withStyles } from '@material-ui/core/styles';
import inlineStyles from './FastEntry.styles';

const FastEntryContainer = (props: IFastEntryProps, ref: React.Ref<IFastEntryHandle>) => {
    return (
        <FastEntryStateProvider>
            <FastEntry ref={ref} {...props} />
        </FastEntryStateProvider>
    );
};

export default withStyles(inlineStyles, { index: 1 })(React.forwardRef(FastEntryContainer));
